<template>
	<div class="slider-container">
		<input class="slider" v-model="localValue" type="range" v-bind="localOptions" />
	</div>
</template>

<script>
export default {
	name: 'InputSlider',
	props: {
		value: { type: Number },
		options: { type: Object, default: () => ({}) },
	},
	watch: {
		localValue: {
			handler() {
				this.$emit('onChange', Number(this.localValue));
			},
			deep: true,
		},
	},
	data() {
		return {
			inputModel: 0,
			localValue: this.value,
			localOptions: {
				...{
					min: 0,
					max: 100,
				},
				...this.options,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.slider-container {
	$height: 4px;
	$radius: 15px;
	$color: var(--seconday-color);

	.slider {
		-webkit-appearance: none;
		width: 100%;
		height: $height;
		background: #ecedf2;
		border-radius: $height;
		outline: none;
		-webkit-transition: 0.2s;
		transition: 0.2s;

		&:hover {
			filter: brightness(0.95);
			transition: opacity 0.2s;
		}
	}

	.slider::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: $radius;
		height: $radius;
		border-radius: 50%;
		background: $color;
		cursor: pointer;
		box-shadow: 0 2px 2px #000000;
	}

	.slider::-moz-range-thumb {
		width: $radius;
		height: $radius;
		border-radius: 50%;
		background: $color;
		cursor: pointer;
		box-shadow: 0 2px 2px #000000;
	}
}
</style>
